module.exports = __webpack_public_path__ + "static/media/kicksharing.d084ca96.png";